module.exports = __webpack_public_path__ + "media/images/teams/logo__24-0fe9f03e7e4c8dc7fb472fe261ca613a.svg";